import React, { Fragment } from 'react';

import numeral from 'numeral';
import moment from 'moment';

import {
  Box,
  makeStyles,
  TableCell,
  TableRow,
  Tooltip,
  colors,
  Avatar,
  IconButton,
  Icon,
  Grid,
  Link,
  Typography,
  Chip
} from '@material-ui/core';

import { green, red, blue } from '@material-ui/core/colors';

import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import BuildIcon from '@material-ui/icons/Build';
import { FaFile } from "react-icons/fa";
import { BsPlayCircleFill } from "react-icons/bs";

const useStyles = makeStyles((theme) => ({
  root: {
  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200]
  },
  sit0: {
    color: colors.red[600],
    fontSize: '1.1em',
    fontWeight: 'bold'
  },
  sit1: {
    color: colors.yellow[800],
    fontSize: '1.1em',
    fontWeight: 'bold'
  },
  sit2: {
    color: colors.green[600],
    fontSize: '1.1em',
    fontWeight: 'bold'
  }
}));

const formatDecimal = (value) => {
  return numeral(value).format('0.00').replace('.', ',');
}

const formatNumber = (value, mask) => {
  return numeral(value).format(mask);
}

const formatDate = (value) => {
  if (value) {
    return moment(value).format('DD/MM/YYYY')
  } else {
    return ""
  }
}

const formatDatetime = (value) => {
  if (value) {
    return moment(value).format('DD/MM/YYYY HH:mm:ss')
  } else {
    return ""
  }
}

const fileSize = (bytes) => {
  var exp = Math.log(bytes) / Math.log(1024) | 0;
  var result = (bytes / Math.pow(1024, exp)).toFixed(2);
  return result + ' ' + (exp == 0 ? 'bytes' : 'KMGTPEZY'[exp - 1] + 'B');
}


const truncateValue = (value, size) => {
  if (value.length > size) {
    return value.substring(size - 3, 0) + '...';
  } else {
    return value;
  }
}
const getIconColor = (item) => {
  return { color: colors.cyan[400] }
}

const getTypeStyle = (item) => {
  return { color: 'white', backgroundColor: 'gray' }
}


const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const Record = ({ icon, item, vision, resultMode, openEdition, openDeletion, openTreatment }) => {

  const classes = useStyles();


  const calculaSituacao = (item) => {
    if (item.status == 1)
      return 1

  }

  const getLabelSituacao = (value) => {
    if (value == 1) {
      return "Sucesso";
    } else if (value == 2) {
      return "Erro"
    } else {
      return "Finalizada";
    }
  }

  const getLabelSituacao2 = (value) => {
    if (value == 1) {
      return "Nova";
    } else if (value == 2) {
      return "Erro"
    } else {
      return "Finalizada";
    }
  }


  const getFieldValue = (column) => {
    try {
      var value = eval(column.field);
      return ((value) ? value : "");
    } catch (error) {
      return "";
    }
  }

  const getStyleActionsAjustment = (resultMode) => {
    var distance = (resultMode.update + resultMode.delete + resultMode.config) * 80;
    return { maxWidth: distance, minWidth: distance };
  }

  return (
    <Fragment>

      <TableRow hover key={item.id} className={classes.root}>

        {resultMode.columns.map((col, index) => (
          (index == 0) ? (

            <TableCell>
              <Box
                noWrap={(col.wrap)}
                alignItems="center"
                display="flex"
                component={Link}
                onClick={() => { (resultMode.update == LEVEL_ACCESS_ENABLED) ? openEdition(item) : {} }}
              >
                <Avatar
                  className={classes.avatar}
                >
                  {<Icon component={icon}
                    style={(item.status == 2) ? { color: red[500] } : { color: green[700] }}
                  ></Icon>}
                </Avatar>
                {getFieldValue(col)}
              </Box>
            </TableCell>

          ) : (

            (col.name == 'Arquivos') ?
              <TableCell width={'100%'}>
                {item.arquivos.map((arquivo, rowIndex) => (
                  <TableRow>
                    <TableCell width={300} style={(arquivo.status == 1) ? { border: "1px solid lightgray", color: green[700] } : { border: "1px solid lightgray", color: red[500] }}>
                      <Box
                        alignItems="center"
                        display="flex"
                        onClick={() => { (resultMode.update == LEVEL_ACCESS_ENABLED) ? openEdition(arquivo) : {} }}
                      >
                        <Avatar
                          className={classes.avatar}
                        >
                          {<Icon component={FaFile} style={getIconColor(arquivo)} ></Icon>}
                        </Avatar>
                        {arquivo.nome}
                      </Box>
                    </TableCell>
                    <TableCell width={100} wrap={false}
                      style={(arquivo.status == 1) ? { border: "1px solid lightgray", color: green[700] } : { border: "1px solid lightgray", color: red[500] }}>{fileSize(arquivo.tamanho)}</TableCell>
                    <TableCell align='center' style={{ border: "1px solid lightgray" }}>
                      <Chip variant="default" style={(arquivo.status == 1) ? { color: 'white', backgroundColor: green[700] } : ((arquivo.status == 3)) ? { color: 'white', backgroundColor: blue[500] } : { color: 'white', backgroundColor: red[500] }}
                        size="medium"
                        label={getLabelSituacao(arquivo.status)}></Chip>
                    </TableCell>
                    <TableCell width={400}
                      style={(arquivo.status == 1) ? { border: "1px solid lightgray", color: green[700] } : { border: "1px solid lightgray", color: red[500] }}>
                      {arquivo.relatorio}
                    </TableCell>

                  </TableRow>
                ))}

              </TableCell>
              :
              <TableCell style={(item.status == 2) ? { color: red[500] } : { color: green[700] }}>

                {(col.name == 'Resultado') ?
                  <Chip variant="default" style={(parseInt(getFieldValue(col)) == 1) ? { color: 'white', backgroundColor: green[600] } : ((parseInt(getFieldValue(col)) == 3)) ? { color: 'white', backgroundColor: blue[500] } : { color: 'white', backgroundColor: red[500] }}
                    size="medium"
                    label={getLabelSituacao2(getFieldValue(col))} ></Chip>
                  :
                  <Typography variant="body" noWrap={(col.wrap)}  >
                    {getFieldValue(col)}
                  </Typography>
                }

              </TableCell>

          )
        ))}

        <TableCell align="right" >
          <Grid container style={getStyleActionsAjustment(resultMode)} >
            {(resultMode.config != LEVEL_ACCESS_HIDE) ? (
              <Grid item
                md={4}
                xl={4}
              >
                <Tooltip title="Tratar">
                  <IconButton
                    color="secondary"
                    disabled={resultMode.config == LEVEL_ACCESS_DISABLED || item.status == 3}
                    children={<BuildIcon />}
                    size="medium"
                    onClick={() => { openTreatment(item) }}></IconButton>
                </Tooltip>
              </Grid>
            ) : ('')}

            {(resultMode.update != LEVEL_ACCESS_HIDE) ? (
              <Grid item
                md={4}
                xl={4}
              >
                <Tooltip title="Processar">
                  <IconButton
                    color="secondary"
                    disabled={(item.status == 3)}
                    children={<BsPlayCircleFill />}
                    size="medium"
                    onClick={() => { openEdition(item) }}>
                  </IconButton>
                </Tooltip>
              </Grid>
            ) : ('')}

            {(resultMode.delete != LEVEL_ACCESS_HIDE) ? (
              <Grid item
                md={4}
                xl={4}
              >
                <Tooltip title={"Excluir"}>
                  <IconButton
                    color="secondary"
                    disabled={resultMode.delete == LEVEL_ACCESS_DISABLED || item.status == 3}
                    children={<DeleteRoundedIcon />}
                    size="medium"
                    onClick={() => { openDeletion(item) }}></IconButton>
                </Tooltip>
              </Grid>
            ) : ('')}

          </Grid>
        </TableCell>

      </TableRow>

    </Fragment >
  );
}

export default Record;